// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Portal_Reports_GetInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /customer-portal/v1/reports/get
 *
 * Validates the request body SHAPE only (types + a real order_item_id).
 * Deliberately does NOT reject an empty `document` or an out-of-enum
 * `type` here — those are business rules the controller checks AFTER
 * this contract passes, mirroring Customer_portal::clientes() (normalize
 * then validate outside the contract). Doing it that way lets the
 * controller answer with the portal's coded envelope (400 invalid_document /
 * invalid_type via sendPortalProblem) instead of this contract's generic,
 * uncoded validation-failed response — see customer_portal_reports.php.
 */
import { registerContract } from './validate'

export interface Portal_Reports_GetInput {
document: string
order_item_id: number
type: string
}

registerContract('Portal_Reports_GetInput', {
  document:      { type: 'string',  required: true },
  order_item_id: { type: 'number',  required: true },
  type:          { type: 'string',  required: true },
})
